export const OPENID_STATE_KEY = 'OpenIdConnect.state';
export const OPENID_NONCE_KEY = 'OpenIdConnect.nonce';
export const OPENID_REFERER_KEY = 'OpenIdConnect.referer';
export const OPENID_AUTH_KEY = 'OpenIdConnect.auth';
export const AUTH_COOKIE = 'Sravni.AmfvdoCXeW'; // Sravni.A - Authentication

export const AUTH_LOGIN_CONFIRMATION_COOKIE = 'Sravni.LCskreDFoQ'; // Sravni.LC - Login Confirmation
export const AUTH_LOGIN_CONFIRMATION_UI_COOKIE = 'Sravni.LCUjavHfgr'; // Sravni.LCU - Login Confirmation UI

export const CROSS_DOMAINS_ACTION_COOKIE = 'Sravni.CDAbsnayoE'; // Sravni.CDA - cross domains actions;

// TODO: Когда кол-во запросов по данным метрики 'nodejs_user_decode_old_format' приблизится к 0 - удалить
// @deprecated
export const AUTH_COOKIE_DEPRECATED = '.AspNet.ApplicationCookie';
// TODO: Когда кол-во запросов по данным метрики 'nodejs_login_confirmation_decode_old_format' приблизится к 0 - удалить
// @deprecated
export const AUTH_LOGIN_CONFIRMATION_COOKIE_DEPRECATED = '.AspNet.LoginConfirmationCookie';
// TODO: Когда кол-во запросов по данным метрики 'nodejs_login_confirmation_decode_old_format' приблизится к 0 - удалить
// @deprecated
export const AUTH_LOGIN_CONFIRMATION_UI_COOKIE_DEPRECATED = '.AspNet.LoginConfirmationUiCookie';
// @deprecated
export const CROSS_DOMAINS_ACTION_COOKIE_DEPRECATED = '.AspNet.CrossDomains';
export const SECURITY_MAX_AGE = 2 * 24 * 60 * 60 * 1000;
export const SESSION_MAX_AGE = (365 + 3 * 30) * 24 * 60 * 60 * 1000;
export const AUTH_ROUTER_PREFIX_DEFAULT = '/openid/v2';
export const CONTEXT = {
  CUSTOM_RENDER: 'authRouterRender'
};

/**
 * Типы провайдеров для авторизации
 */
export let IDENTITY_PROVIDER = /*#__PURE__*/function (IDENTITY_PROVIDER) {
  IDENTITY_PROVIDER["LOCAL"] = "local";
  IDENTITY_PROVIDER["ESIA"] = "esia";
  return IDENTITY_PROVIDER;
}({});
export let AUTHENTICATION_UI_TYPE = /*#__PURE__*/function (AUTHENTICATION_UI_TYPE) {
  AUTHENTICATION_UI_TYPE["POPUP"] = "popup";
  AUTHENTICATION_UI_TYPE["PAGE"] = "page";
  return AUTHENTICATION_UI_TYPE;
}({});

/** Типы авторизации */
export let LOGIN_TYPE = /*#__PURE__*/function (LOGIN_TYPE) {
  LOGIN_TYPE["PHONE"] = "phone";
  LOGIN_TYPE["EMAIL"] = "email";
  LOGIN_TYPE["ESIA"] = "esia";
  LOGIN_TYPE["OTAC"] = "otac";
  return LOGIN_TYPE;
}({});

/** Типы логаута */
export let LOGOUT_TYPE = /*#__PURE__*/function (LOGOUT_TYPE) {
  LOGOUT_TYPE["SIMPLE"] = "simple";
  return LOGOUT_TYPE;
}({});
export let CROSS_DOMAINS_ACTION = /*#__PURE__*/function (CROSS_DOMAINS_ACTION) {
  CROSS_DOMAINS_ACTION["LOGIN"] = "login";
  CROSS_DOMAINS_ACTION["LOGOUT"] = "logout";
  return CROSS_DOMAINS_ACTION;
}({});
export let QUERY = /*#__PURE__*/function (QUERY) {
  QUERY["TYPE"] = "type";
  QUERY["REFERER"] = "referer";
  QUERY["RETURN_URL"] = "returnUrl";
  QUERY["REDIRECT"] = "redirect";
  QUERY["LOGIN_TYPE"] = "loginType";
  QUERY["LOGOUT_TYPE"] = "logoutType";
  QUERY["ACTION"] = "action";
  QUERY["PROMPT"] = "prompt";
  QUERY["USER_NAME"] = "hash";
  return QUERY;
}({});
/**
 * @enum Типы ошибок
 */
export let ACCESS_DENIED_REASON = /*#__PURE__*/function (ACCESS_DENIED_REASON) {
  ACCESS_DENIED_REASON["UNKNOWN"] = "unknown";
  ACCESS_DENIED_REASON["ESIA_ACCOUNT_ALREADY_LINKED"] = "EsiaAccountAlreadyLinked";
  ACCESS_DENIED_REASON["USER_ALREADY_HAS_ESIA_ACCOUNT"] = "UserAlreadyHasEsiaAccount";
  ACCESS_DENIED_REASON["ESIA_AUTH_FAILED"] = "EsiaAuthFailed";
  ACCESS_DENIED_REASON["ESIA_CONSENT_FAILED"] = "EsiaConsentFailed";
  ACCESS_DENIED_REASON["ESIA_USER_IS_NOT_VERIFIED"] = "EsiaUserIsNotVerified";
  ACCESS_DENIED_REASON["FAILED_TO_FETCH_USER_INFO_FROM_ESIA"] = "FailedToFetchUserInfoFromEsia";
  ACCESS_DENIED_REASON["FAILED_TO_LOGIN_VIA_ESIA"] = "FailedToLoginViaEsia";
  ACCESS_DENIED_REASON["NOT_ENOUGH_INFO_FOR_USER_AGREEMENTS"] = "NotEnoughInfoForUserAgreements";
  ACCESS_DENIED_REASON["FAILED_TO_STORE_DATA_FOR_SIGN"] = "FailedToStoreDataForSign";
  ACCESS_DENIED_REASON["FAILED_TO_SIGN_USER_AGREEMENTS"] = "FailedToSignUserAgreements";
  ACCESS_DENIED_REASON["FAILED_TO_REQUEST_USER_AGREEMENTS_SERVICE"] = "FailedToRequestUserAgreementsService";
  ACCESS_DENIED_REASON["FAILED_TO_FETCH_DATA_FOR_USER_AGREEMENTS"] = "FailedToFetchDataForUserAgreements";
  ACCESS_DENIED_REASON["FAILED_TO_START_LOADING_DOCUMENTS_FROM_ESIA"] = "FailedToStartLoadingDocumentsFromEsia";
  ACCESS_DENIED_REASON["FAILED_TO_FIND_USER_FOR_LINKING"] = "FailedToFindUserForLinking";
  return ACCESS_DENIED_REASON;
}({});
export let ROUTES = /*#__PURE__*/function (ROUTES) {
  ROUTES["LOGIN"] = "/login";
  ROUTES["LOGIN_CONFIRM"] = "/login/confirm";
  ROUTES["CALLBACK"] = "/callback";
  ROUTES["SUCCESS"] = "/success";
  ROUTES["LOGOUT"] = "/logout";
  ROUTES["LOGOUT_CALLBACK"] = "/logout/callback";
  ROUTES["SILENT_SIGNIN"] = "/silent/signin";
  ROUTES["SILENT_SIGNIN_VERIFY"] = "/silent/signin/verify";
  ROUTES["LOADING"] = "/loading";
  ROUTES["IFRAMES"] = "/crossdomains/iframes/";
  ROUTES["ACTION"] = "/crossdomains/action/";
  ROUTES["STATISTICS"] = "/crossdomains/statistics/";
  return ROUTES;
}({});
//# sourceMappingURL=auth.js.map